import { html, render } from 'lit-html'
import User from '@polleverywhere/core/lib/models/user'
import { normalizeXhrError } from '@polleverywhere/core/lib/util'
import { notify } from '../../../components/notification_manager'
import { recentPresentations } from '../../../states/participant/util/recentPresentations'

function generateListItem (username) {
  return html`
  <li>
    <a href="/${username}" data-presenter=${username}>
      <span class="pollev-home__recent__presenter-prefix">pollev.com/</span>${username}
    </a>
  </li>`
}

export default class RecentList extends Backbone.View {
  get className () {
    return 'pollev-home__recent__list'
  }

  get tagName () {
    return 'ul'
  }

  get id () {
    return 'aria-pollev-recent-list'
  }

  get attributes () {
    return {
      role: 'menu',
      'aria-labelledby': 'aria-pollev-recent-toggle'
    }
  }

  get events () {
    return {
      'click a': 'joinPastPresenter'
    }
  }

  render () {
    const usernames = recentPresentations.list() || []

    render(html`${usernames.map(generateListItem)}`, this.el)

    return this
  }

  joinPastPresenter (e) {
    e.preventDefault()

    const username = $(e.target).attr('data-presenter')

    User.check(username)
      .then((data) => {
        if (!data.exists) {
          recentPresentations.remove(username)
          $(e.target).text('Presenter not found').addClass('pollev-home__recent__error')
        }
        this.trigger('join', username, !!data.exists)
      }).catch((xhr) => {
        const error = normalizeXhrError(xhr)
        notify(this.el, {
          title: error.message,
          type: 'error'
        })
      })
  }
}
